var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    [
      _c(
        "td",
        { staticClass: "active" },
        [
          _vm.canChangeMeal
            ? [
                _c("singleselect", {
                  attrs: {
                    checked: _vm.expressMeal.meal
                      ? _vm.expressMeal.meal.id
                      : null,
                    disabled: !_vm.canEdit || !_vm.typeId,
                    errors: _vm.errors,
                    options: _vm.availableMeals,
                    title: _vm.trans("menu_planner.entity.finalMeal"),
                    name: "finalMeal"
                  },
                  on: { "option-selected": _vm.changeMeal }
                })
              ]
            : [
                _c("span", { staticClass: "error" }, [
                  _vm._v(_vm._s(_vm.expressMeal.meal.name))
                ])
              ]
        ],
        2
      ),
      _vm._v(" "),
      _vm.loading
        ? [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c("td")
          ]
        : !_vm.loading && _vm.expressMeal.meal
        ? [
            _c("td", [
              _c("span", {
                domProps: { textContent: _vm._s(_vm.expressMeal.meal.id) }
              })
            ]),
            _vm._v(" "),
            _c("td", [
              _c("span", {
                domProps: {
                  textContent: _vm._s(
                    Math.round(_vm.expressMeal.meal.rate * 100) / 100
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                _vm._l(_vm.expressMeal.meal.mealBadges, function(mealBadge) {
                  return [
                    mealBadge.validFrom <= _vm.date &&
                    mealBadge.validTo >= _vm.date
                      ? _c("div", { key: mealBadge.id }, [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.showMealBadge(mealBadge.badge.id)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-link" }),
                              _vm._v(
                                " " +
                                  _vm._s(mealBadge.badge.name) +
                                  "\n          "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "td",
              _vm._l(_vm.mealTags, function(tag, tagIndex) {
                return _c("span", { key: tagIndex }, [
                  _vm._v(_vm._s(tag.value) + " "),
                  _c("br")
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("td", [
              _c(
                "div",
                [
                  _vm._l(_vm.expressMeal.meal.servings, function(
                    serving,
                    servingIndex
                  ) {
                    return [
                      _c("span", {
                        key: "span-" + servingIndex,
                        domProps: { textContent: _vm._s(serving.size) }
                      }),
                      _vm._v(" "),
                      _c("br", { key: "br-" + servingIndex })
                    ]
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _c(
                "div",
                [
                  _vm._l(_vm.expressMeal.meal.servings, function(
                    serving,
                    servingIndex
                  ) {
                    return [
                      _c("span", {
                        key: "span-" + servingIndex,
                        domProps: {
                          textContent: _vm._s(
                            _vm.dcNumberFormat(serving.productionCost)
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("br", { key: "br-" + servingIndex })
                    ]
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _c(
                "div",
                [
                  _vm._l(_vm.expressMeal.meal.servings, function(
                    serving,
                    servingIndex
                  ) {
                    return [
                      _c("span", {
                        key: "span-" + servingIndex,
                        style:
                          serving.suggestedLowestPrice === null
                            ? "color: red"
                            : "",
                        domProps: {
                          textContent: _vm._s(
                            serving.suggestedLowestPrice === null
                              ? "Brak ceny"
                              : _vm.dcNumberFormat(serving.suggestedLowestPrice)
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("br", { key: "br-" + servingIndex })
                    ]
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _c("div", { staticClass: "btn-set pull-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: { disabled: !_vm.canEdit },
                    on: { click: _vm.remove }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.trans("menu_planner_select.remove_meal")) +
                        "\n        "
                    )
                  ]
                )
              ])
            ])
          ]
        : [
            _c("td"),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _c("td")
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("span", {
        staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("span", {
        staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("span", {
        staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("span", {
        staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("span", {
        staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("span", {
        staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43be0d6d", { render: render, staticRenderFns: staticRenderFns })
  }
}